import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ACLStore from "lib/aclStore";

export default (store, pathName = "courseOverview") => ({
  path: pathName,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "courseOverview" */ "./components"),
      import(
        /* webpackChunkName: "courseOverview" */ "../../routes/NewCourseUnitPlansOverview/components"
      ),
      import(
        /* webpackChunkName: "courseOverview" */ "../NewCourseUnitPlansOverviewV2/components"
      ),
    ]).then(([importedModule0, importedModule1, importedModule2]) => {
      const component = ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")
        ? importedModule2.default
        : ACLStore.can("FeatureFlag:EnableNewCourseOverviewModals")
        ? importedModule1.default
        : importedModule0.default;
      return component;
    })
  ),
});
